import axios from "axios";
import { useState } from "react";
import { NotificationManager } from "react-notifications";
import Modal from "../../components/Modal/Modal";
import useAuth from "../../hooks/useAuth";
import { BASE_URL } from "../../utils/Element";
import AddExclusiveData from "./components/AddExclusiveData";

const initialData = {
  client_name: "",
  client_id: "",
  client_type: "contact",
  property_id: "",
  current_list_date: "",
  initial_list_date: "",
  expiration_date: "",
  gross_commission_company: "",
  asking_price: "",
  asking_cap_rate: "",
  anual_rent: "",
  lease_expiration_date: "",
  lease_type: "",
  brokerage_commission: "",
  contact_id:"",
  portfolio:0,
  portfolio_id:""
};

const AddExclusiveModal = ({ showModal, onClose, onCallApi }) => {
  const [config] = useAuth();
  const [error, setError] = useState();
  const [disable, setDisable] = useState(false);
  const [formData, setFormData] = useState(initialData);
  const [search, setSearch] = useState("");

  const handleClose = () => {
    setFormData(initialData);
    onClose();
    setError();
    setDisable(false);
    setSearch("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setDisable(true);
    const dataToSend = {
      property_id: formData?.property_id,
      contact_id:  formData?.contact_id ,
      contact_id: formData?.client_type === "contact" ? formData?.client_id : formData?.contact_id,
      company_id: formData?.client_type === "company" ? formData?.client_id : "",
      brokerage_commission: formData?.brokerage_commission,
      current_list_date: formData?.current_list_date,
      initial_list_date: formData?.initial_list_date,
      expiration_date: formData?.expiration_date,
      anual_rent: formData?.anual_rent,
      asking_price: formData?.asking_price,
      lease_expiration_date: formData?.lease_expiration_date,
      lease_type: formData?.lease_type,
      asking_cap_rate: formData?.asking_cap_rate,
      portfolio: formData?.portfolio,
      portfolio_id: formData?.portfolio_id
    };

    axios
      .post(`${BASE_URL}/add-exclusive`, dataToSend, config)
      .then((res) => {
        handleClose();
        onCallApi();
      })
      .catch((err) => {
        setError(err.response?.data?.errors);
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      })
      .finally(() => setDisable(false));
  };

  return (
    <Modal title={`Add Exclusive`} desc={`Add the exclusive information.`} show={showModal} onClose={handleClose}>
      <AddExclusiveData
        formData={formData}
        error={error}
        onSetFormData={(value) => {
          setFormData(value);
        }}
        onSetError={(value) => setError(value)}
        handleSubmit={handleSubmit}
        handleClose={handleClose}
        search={search}
        showModal={showModal}
        disable={disable}
      />
    </Modal>
  );
};

export default AddExclusiveModal;
